export const backendUrl = (removeAdminKey?: boolean) => {
  const {
    REACT_APP_BACKEND_PROTOCOL,
    REACT_APP_BACKEND_HOST,
    REACT_APP_BACKEND_PORT,
    REACT_APP_ADMIN_SUFFIX,
  } = process.env;

  if (
    !REACT_APP_BACKEND_PROTOCOL ||
    !REACT_APP_BACKEND_HOST ||
    !REACT_APP_BACKEND_PORT ||
    (!removeAdminKey && !REACT_APP_ADMIN_SUFFIX)
  ) {
    return "";
  }

  return `${REACT_APP_BACKEND_PROTOCOL}://${REACT_APP_BACKEND_HOST}:${REACT_APP_BACKEND_PORT}${
    removeAdminKey ? "" : `/${REACT_APP_ADMIN_SUFFIX}`
  }`;
};
